import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons"

export const FacebookSquare = (props) => {
  return <FontAwesomeIcon faIcon={faFacebookSquare} {...props} />
}
